import { createContext, useCallback, useContext, useRef, useState } from 'react';

interface ViewContextValue {
  setView: (viewId: string) => void;
  removeView: () => void;
  view: string | undefined;
  container: React.RefObject<HTMLDivElement>;
}

const ViewContext = createContext<ViewContextValue | null>(null);

export function useView() {
  const context = useContext(ViewContext);

  if (context === null) {
    throw new Error('useView must be used within a ViewProvider');
  }

  return context;
}

interface ViewProviderProps {
  children: React.ReactNode;
}

export function ViewProvider({ children }: ViewProviderProps) {
  const [view, setView] = useState<string | undefined>(undefined);
  const removeView = useCallback(() => setView(undefined), []);
  const container = useRef<HTMLDivElement>(null);

  return <ViewContext.Provider value={{ container, view, setView, removeView }}>{children}</ViewContext.Provider>;
}
